import type { CSSProperties } from 'react';
import { titleCaseStatus } from '../lib/format';
import type { PillSize } from './ui/Pill';

// Tag system (design manager spec, Bobby 1 Nov 2026): Priced and Invoiced share the
// staff-assignee neutral (the words tell them apart); Unpriced is an outline.
const styles: Record<string, CSSProperties> = {
  unpriced: { color: 'var(--tag-unpriced-ink)', boxShadow: 'inset 0 0 0 1px var(--tag-unpriced-border)' },
  priced: { color: 'var(--tag-neutral-ink)', background: 'var(--tag-neutral-fill)' },
  invoiced: { color: 'var(--tag-neutral-ink)', background: 'var(--tag-neutral-fill)' },
};

const sizes: Record<PillSize, string> = {
  sm: 'h-[26px] px-2.5 text-[12px]',
  md: 'h-7 px-3 text-[13px]',
};

export function AccountingBadge({ status, size = 'md' }: { status?: string | null; size?: PillSize }) {
  const value = status || 'unpriced';
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full font-semibold ${sizes[size]}`}
      style={styles[value] ?? styles.unpriced}
    >
      {titleCaseStatus(value)}
    </span>
  );
}
